const WarehouseLocationType = `
  id
  description
  inactive
`;

export default WarehouseLocationType;
